import { render, staticRenderFns } from "./EditVenueLabelLoader.vue?vue&type=template&id=4048a82d"
import script from "./EditVenueLabelLoader.vue?vue&type=script&lang=ts"
export * from "./EditVenueLabelLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports